export enum AccountCustomerAccountsStates {
  DISABLED = 'disabled',
  OPTIONAL = 'optional',
  REQUIRED = 'required',
}

export enum CardBrands {
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
}

export enum CartFulfillmentKinds {
  AUTO = 'auto',
  DELIVERY = 'delivery',
  DROP_OFF = 'drop_off',
  PICKUP = 'pickup',
  SHIPPING = 'shipping',
  TABLESIDE = 'tableside',
}

export enum CartFulfillmentCourierAction {
  LEAVE_AT_DOOR = 'leave_at_door',
  MEET_AT_DOOR = 'meet_at_door',
}

export enum CartFulfillmentScheduleTypes {
  ASAP = 'asap',
  SCHEDULED = 'scheduled',
}

export enum CartItemTypes {
  DIGITAL_GIFT_CARDABLE = 'digital_gift_cardable',
  MENU_ITEMABLE = 'menu_itemable',
  PHYSICAL_GIFT_CARDABLE = 'physical_gift_cardable',
  PRODUCTABLE = 'productable',
  TICKETABLE = 'ticketable',
}

export enum DeliveryTypes {
  DOOR_DASH = 'door_dash',
  IN_HOUSE = 'in_house',
  UBER = 'uber',
}

export enum DiscountCodeTypes {
  AMOUNT = 'amount_money',
  PERCENT = 'percent',
}

export enum MessageActions {
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  EXPECTED = 'expected',
  MESSAGE = 'message',
  ORDERED = 'ordered',
  REQUESTED = 'requested',
  SIGNED_UP = 'signed_up',
  SUBMITTED = 'submitted',
  SUBSCRIBED = 'subscribed',
  SUGGESTED = 'suggested',
}

export enum PaymentMethods {
  APPLE_PAY = 'apple_pay',
  CARD = 'card',
  GOOGLE_PAY = 'google_pay',
}

export enum PaymentGateways {
  SPREEDLY = 'spreedly',
  SQUARE = 'square',
  STRIPE = 'stripe',
}

export enum ShopGiftCardKinds {
  DIGITAL = 'digital',
  PHYSICAL = 'physical',
}

// export enum OrderBillingAddressKinds {
//   OTHER = 'other',
//   SAME_AS_SHIPPING = 'same_as_shipping',
// }
